import { type FC } from 'react'
import styled from '@emotion/styled'

import SectionBase, * as Section from '@segment/matcha/recipes/Section'
import CopyTextBase, * as CopyText from '@segment/matcha/recipes/CopyText'

import PredictiveAudiencesImage from './PredictiveAudiencesImage'

const copy = {
  title: `Say goodbye to guesswork and hello to precise personalization`,
  description: `CustomerAI Predictions gives marketers the power of predictive AI, making it easy to uncover patterns in historical customer data, predict future behavior, and discover audiences primed for engagement—saving teams time, boosting campaign performance, and improving personalization.`,
}

const PredictiveAudiences: FC = () => {
  return (
    <Wrapper>
      <SectionBase variant="2Col" reverse={true}>
        <Section.Copy alignSelf="center">
          <CopyTextBase>
            <CopyText.Heading variant="h2" tag="h2">
              {copy.title}
            </CopyText.Heading>
            <CopyText.Description variant="pLarge" tag="p">
              {copy.description}
            </CopyText.Description>
          </CopyTextBase>
        </Section.Copy>
        <Section.Contents>
          <PredictiveAudiencesImage />
        </Section.Contents>
      </SectionBase>
    </Wrapper>
  )
}

const Wrapper = styled.div`
  background-color: ${({ theme }) => theme.palette.neutrals.white[100]};
  max-width: 1440px;
  margin: 0 auto;
`

export default PredictiveAudiences
